export enum Position {
    Left = 'left',
    Right = 'right',
    Bottom = 'bottom',
    Top = 'top',
    None = 'none',
}
